<template>
  <div class="page">
    <div class="content">
      <div class="logo">
        <img src="../assets/icon_logo.png" alt="" />
        <span>伴伴直播</span>
      </div>
      <div class="title">
        <p>
          账号注销后，所有资料将被删除<br />
          账号将无法使用，确认注销吗？
        </p>
      </div>
      <div class="form-box">
        <div class="form-div">
          <div class="input-box">
            <span>邮箱：</span>
            <el-input
              v-model="email"
              placeholder="请输入邮箱"
              clearable
              style="width: 300px"
            ></el-input>
          </div>
          <div class="input-box">
            <span>密码：</span>
            <el-input
              type="password"
              v-model="userPassword"
              placeholder="请输入密码"
              style="width: 300px"
              clearable
            ></el-input>
          </div>
          <div class="button-box">
            <el-button class="button-style" @click="onDialog">
              确认注销
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="head-box">
      <div class="logo1">
        <img src="../assets/icon_logo.png" alt="" />
        <span>伴伴直播</span>
      </div>
      <p>©武汉遥景互动科技有限公司</p>
    </div> -->
    <el-dialog
      title="请完成安全验证"
      :visible.sync="dialogVisible"
      width="340px"
    >
      <div class="code-dia">
        <img
          :src="'data:image/png;base64,' + codeImg"
          alt=""
          @load="getdebrisImageWidth"
          :style="{ left: `${sliderPosition}px` }"
          class="code-style newCode"
        />
        <img
          :src="'data:image/png;base64,' + codeBack"
          alt=""
          @load="getImageWidth"
          class="code-style"
        />
        <div class="slider-box">
          <div
            class="slider"
            :style="{ left: `${sliderPosition}px` }"
            @mousedown="startSliding"
          ></div>
          <span>向右拖动滑块填充图片</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Message } from "element-ui";
import CryptoJS from "crypto-js";
import { captcha, cancellation } from "../api/api";
export default {
  name: "UserLogout",
  data() {
    return {
      email: "",
      userPassword: "",
      token: "",
      offset: 0, // 拼图块的偏移量
      isSliding: false,
      solved: false,
      codeBack: "",
      codeImg: "",
      input: "",
      sliderWidth: 270, // 滑块移动的宽度
      puzzleWidth: 310, // 拼图的总宽度
      sliderPosition: 0, // 当前滑块位置
      dialogVisible: false,
      debrisWidth: null,
      imageWidth: null,
    };
  },
  computed: {},
  components: {},
  methods: {
    getImageWidth(event) {
      this.imageWidth = event.target.naturalWidth;
    },
    getdebrisImageWidth(event) {
      this.debrisWidth = event.target.naturalWidth;
    },
    async captchaImg() {
      const { data } = await captcha();
      if (data.data) {
        this.codeImg = data.data.jigsawImageBase64;
        this.codeBack = data.data.originalImageBase64;
        this.token = data.data.token;
      } else {
        Message.error(data.repMsg);
      }
    },
    startSliding(event) {
      const offsetX = event.clientX - this.sliderPosition;

      const onMouseMove = (e) => {
        this.sliderPosition = e.clientX - offsetX;

        // 限制滑块位置在合法范围内
        if (this.sliderPosition < 0) this.sliderPosition = 0;
        if (this.sliderPosition > this.sliderWidth)
          this.sliderPosition = this.sliderWidth;
      };

      const onMouseUp = async (e) => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);

        const encryptedPassword = CryptoJS.MD5(this.userPassword).toString();
        const res = await cancellation({
          email: this.email,
          userPassword: encryptedPassword,
          captchaVO: {
            token: this.token,
            captchaType: "slide",
            captchaPoint: { x: String(this.sliderPosition), y: "5" },
          },
        });
        if (res.data.resp_code == 1) {
          Message.success("注销成功");
        } else {
          Message.error(res.data.resp_msg);
          this.captchaImg();
        }
        this.dialogVisible = false;
        this.sliderPosition = 0; // 重置滑块
      };

      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
    },
    onDialog() {
      if (this.email && this.userPassword) {
        this.dialogVisible = true;
        this.captchaImg();
      } else {
        Message.error("请先输入邮箱和密码");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
  width: 100vw;
  height: 100vh;
}
.content {
  width: 100%;
  height: 90%;
  background: url("../assets/one.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: right;
}
.logo {
  display: flex;
  align-items: center;
  padding: 50px;
  img {
    width: 40px;
    height: 40px;
  }
  span {
    font-size: 20px;
    font-weight: bold;
    padding-left: 20px;
  }
}
.title {
  font-size: 48px;
  text-align: center;
  font-weight: bold;
}
.form-div {
  // width: 50%;
}
.form-box {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 60px;
  .input-box {
    display: flex;
    align-items: center;
    margin: 20px 0;
    span {
      width: 60px;
    }
  }
}
.button-box {
  display: flex;
  align-items: center;
  justify-content: center;
  .button-style {
    width: 300px;
  }
}
.code-style {
  // height: 150px;
}
.newCode {
  position: absolute;
}
.code-dia {
  position: relative;
}
.slider-box {
  border: 1px solid #ccc;
  height: 40px;
  border-radius: 5px;
  text-align: center;
  line-height: 40px;
}
.slider {
  position: absolute;
  width: 40px; /* 滑块的宽度 */
  height: 40px;
  // background-color: #4caf50;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background: #ccc;
  cursor: pointer;
  user-select: none; /* 禁止用户选择文本 */
}
.head-box {
  height: 10%;
  display: flex;
  align-items: center;
  p {
    padding-left: 30%;
  }
}
.logo1 {
  display: flex;
  align-items: center;
  // padding: 20px;
  padding-left: 50px;
  // position: absolute;
  img {
    width: 40px;
    height: 40px;
  }
  span {
    font-size: 20px;
    font-weight: bold;
    padding-left: 20px;
  }
}
</style>
